import type { NavigationItem as NavigationLink } from '@cvo/ui/components';

/** The navigation items as `Navigation` component links, with the item of the current route. */
export function useNavigationLinks() {
  const { navigationItems } = useNavigationItems();
  const route = useRoute();
  const router = useRouter();

  const links = computed<NavigationLink[]>(() => navigationItems.value.map(item => ({
    ...item,
    href: typeof item.to === 'string' ? item.to : router.resolve(item.to).href,
  })));

  const activeId = computed(() => links.value.find(link => link.href === route.path)?.id);

  return { links, activeId };
}
